'use strict';

function controller (
    employeeReviewsModalService,
    viewport,
    dataBrokerService,
    $window,
    $timeout,
    modalService,
    $cookies,
    $sce
) {
    const ctrl = this;
    const EMPLOYEE_CARD_WIDTH = 52;
    const MAX_CAROUSEL_EMPLOYEES = 9;

    ctrl.$onDestroy = () => {
        if (ctrl.isInModal !== 'modal'){
            employeeReviewsModalService.releaseCloseCallbacks();
        }
    };

    ctrl.$onInit = () => {
        ctrl.hover = false;

        if (ctrl.isInModal !== 'modal'){
            employeeReviewsModalService.registerNoPrefCallback(ctrl.setPref);
            employeeReviewsModalService.releaseCloseCallbacks();
        } else {
            ctrl.noPref = employeeReviewsModalService.getPref();
        }

        ctrl.isMobile = viewport.isMobile();
        ctrl.isTablet = viewport.isTablet();

        dataBrokerService.getItem('employees').then((employees) => {
            ctrl.employees = employees;
            ctrl.isFormSubmitting = false;
            angular.forEach(ctrl.employees, employee => {
                if (employee.imageUrl && employee.imageUrl.indexOf('http://') > -1) {
                    let newurl = employee.imageUrl.replace("http://", "https://");
                    employee.imageUrl = newurl;
                }
                if (angular.isString(employee.titleText) && employee.titleText.length < 4) {
                    employee.titleText = "";
                }
                if (employee.combinedEmpAvgRatingNbr && !!Number(employee.combinedEmpAvgRatingNbr)) {
                    employee.showRating = true;
                }
                if (employee.combinedEmpAvgRatingNbr) {
                    employee.combinedEmpAvgRatingNbr = parseFloat(employee.combinedEmpAvgRatingNbr).toFixed(1);
                    employee.starHTML = $sce.trustAsHtml((employee.starHTML).toString());
                }
                employee.hasExperienceSection = employee.industryStartDtUtc && employee.dealerEmpStartDtUtc == null;
                employee.hasBio = typeof employee.shortBioText === 'string' && employee.shortBioText.length > 3; // 3 accounts for use of NaN and whitespace
            });

            employeeReviewsModalService.registerSelectCallback((index, fromModal) => {
                ctrl.employeeIndex = index;

                if (fromModal){
                    if (ctrl.noPref) {
                        ctrl.hasPref(ctrl.employeeIndex);
                    }
                    const indexParsed = parseInt(index);
                    if (!ctrl.halfFace) {
                        ctrl.carouselPage = indexParsed;

                        if (ctrl.carouselPage >= ctrl.employees.length - 3) {
                            ctrl.carouselPage = ctrl.employees.length - 3;
                        }
                    } else if (index > MAX_CAROUSEL_EMPLOYEES && indexParsed !== ctrl.employees.length) {
                        window.localStorage.setItem('selectedEmployee', index);
                        ctrl.carouselPage = indexParsed;

                        if (ctrl.carouselPage >= ctrl.employees.length - 10) {
                            ctrl.carouselPage = ctrl.employees.length - 10;
                        }

                        ctrl.moveToFront = true;
                        ctrl.moveToFrontIndex = parseInt(ctrl.employeeIndex);
                        ctrl.moveToFrontImageUrl = ctrl.employees[ctrl.moveToFrontIndex].imageUrl;

                        $timeout(() => {
                            const scroller = $window.document.getElementsByClassName('half-face-scroll-div')[0];
                            if (scroller) {
                                scroller.scrollLeft = 0;
                            }
                        },0);
                    } else if (index <= MAX_CAROUSEL_EMPLOYEES && indexParsed !== ctrl.employees.length) {
                        ctrl.carouselPage = parseInt(0);
                        employeeReviewsModalService.setPage(0);
                        ctrl.moveToFront = false;
                        $timeout(() => {
                            const scroller = $window.document.getElementsByClassName('half-face-scroll-div')[0];
                            if (scroller) {
                                scroller.scrollLeft = (+index + 1) * EMPLOYEE_CARD_WIDTH;
                            }
                        },0);
                    }
                }

                employeeReviewsModalService.saveState(ctrl.employeeIndex,ctrl.carouselPage);
            });

            if (employeeReviewsModalService.getSelected() === undefined) {
                const fiveStarEmployeeId = ( $cookies.get('FiveStarSelectedEmployee') || undefined );
                const fiveStarEmployee = employees.find(emp => emp.id == fiveStarEmployeeId);
                const fiveStarIndex = employees.indexOf(fiveStarEmployee);
                if (fiveStarEmployeeId && fiveStarIndex > 0){
                    ctrl.selectEmployee(fiveStarIndex);
                    ctrl.employeeIndex = fiveStarIndex;

                    ctrl.selectEmployeeAndMoveIntoView();

                } else {
                    ctrl.selectEmployee(ctrl.employees.length);
                }
            } else {
                const state = employeeReviewsModalService.getState();
                ctrl.employeeIndex = state.index;
                const stateIndexParsed = parseInt(state.index);
                const employeeIndexParsed = parseInt(ctrl.employeeIndex);
                employeeReviewsModalService.setSelected(String(ctrl.employeeIndex), false);
                if (state.index > MAX_CAROUSEL_EMPLOYEES && stateIndexParsed !== ctrl.employees.length) {
                    ctrl.carouselPage = stateIndexParsed;
                    employeeReviewsModalService.setPage(ctrl.carouselPage);

                    if (ctrl.carouselPage >= ctrl.employees.length - 10) {
                        ctrl.carouselPage = ctrl.employees.length - 10;
                    }

                    ctrl.moveToFront = true;
                    ctrl.moveToFrontIndex = employeeIndexParsed;
                    ctrl.moveToFrontImageUrl = ctrl.employees[ctrl.moveToFrontIndex].imageUrl;
                }
                ctrl.noPref = (employeeIndexParsed === ctrl.employees.length) ? true : false;
            }
        });

    };

    ctrl.updateImageUrl = function() {
        return {
            'background-image': `url(${ctrl.moveToFrontImageUrl})`
        };
    };

    ctrl.selectEmployee = function(index) {
        employeeReviewsModalService.saveState(index,0);
        employeeReviewsModalService.setSelected(String(index), false);
        employeeReviewsModalService.setEmployeeToOpen(String(index));
        window.localStorage.setItem('selectedEmployee', ctrl.employeeIndex);
        ctrl.noPref = (parseInt(index) === ctrl.employees.length) ? true : false;
    };

    ctrl.setEmployeeToOpen = function(index) {
        employeeReviewsModalService.setEmployeeToOpen(String(index));
    };

    ctrl.openSlider = function () {
        employeeReviewsModalService.triggerSlider();
    };

    ctrl.setNoPrefByCard = function () {
        employeeReviewsModalService.triggerNoPref(true);
        ctrl.selectEmployee(ctrl.employees.length);
    };

    ctrl.tempSelect = function (index) {
        ctrl.hover = true;
        ctrl.previewIndex = index;
    };

    ctrl.tempUnselect = function () {
        ctrl.hover = false;
    };

    ctrl.hasPref = function (index) {
        if (ctrl.noPref == true && parseInt(index) !== ctrl.employees.length ) {
            ctrl.noPref = !ctrl.noPref;
            employeeReviewsModalService.setPref(ctrl.noPref);

            if (ctrl.isInModal === 'modal'){
                employeeReviewsModalService.triggerNoPref(ctrl.noPref);
            }
        }

        employeeReviewsModalService.saveState(ctrl.employeeIndex, ctrl.carouselPage);
    };

    ctrl.setPref = function (bool) {
        ctrl.noPref = bool;
    };

    ctrl.selectEmployeeAndMoveIntoView = function () {
        const employeeIndexParsed = parseInt(ctrl.employeeIndex);
        if (ctrl.employeeIndex > MAX_CAROUSEL_EMPLOYEES && employeeIndexParsed !== ctrl.employees.length) {
            ctrl.carouselPage = employeeIndexParsed;
            employeeReviewsModalService.setPage(ctrl.carouselPage);

            if (ctrl.carouselPage >= ctrl.employees.length - 10) {
                ctrl.carouselPage = ctrl.employees.length - 10;
            }

            ctrl.moveToFront = true;
            ctrl.moveToFrontIndex = employeeIndexParsed;
            ctrl.moveToFrontImageUrl = ctrl.employees[ctrl.moveToFrontIndex].imageUrl;
        }
        employeeReviewsModalService.setSelected(String(ctrl.employeeIndex), true);
        ctrl.scrollOnLoad(0);
        ctrl.noPref = (employeeIndexParsed === ctrl.employees.length) ? true : false;
    };

    modalService.get('lead-form').afterOpen(() => {
        if (ctrl.employees) {
            const currentIndex = window.localStorage.getItem('selectedEmployee');
            if (currentIndex) {
                ctrl.selectEmployee(currentIndex);
            }
        }
    });

    modalService.get('lead-form').afterClose(() => {
        ctrl.selectEmployeeAndMoveIntoView();
    });

    ctrl.scrollOnLoad = function (i = 1) {
        const employeeIndexParsed = parseInt(ctrl.employeeIndex);
        const normalCarousel = $window.document.getElementsByClassName('normal-mode-container')[0];
        if (normalCarousel && i == 1) {
            i = 0;
        }
        const scrollers = $window.document.getElementsByClassName('half-face-scroll-div');
        if (scrollers[i]) {
            if (ctrl.employeeIndex && ctrl.employeeIndex <= MAX_CAROUSEL_EMPLOYEES && employeeIndexParsed !== ctrl.employees.length) {
                const scrollTo = ctrl.employeeIndex;
                $timeout(() => {
                    scrollers[i].scrollLeft = (+scrollTo + 1) * EMPLOYEE_CARD_WIDTH;
                },0);
            } else if ((employeeIndexParsed === ctrl.employees.length) || (ctrl.isInModal !== "modal")) {
                $timeout(() => {
                    scrollers[i].scrollLeft = 0;
                },0);
            }
        }
        window.localStorage.setItem('selectedEmployee', ctrl.employeeIndex);
    };
}

controller.$inject = [
    'employeeReviewsModalService',
    'viewport',
    'dataBrokerService',
    '$window',
    '$timeout',
    'modalService',
    '$cookies',
    '$sce'
];

export default controller;
